import { useQuery } from '@tanstack/react-query'
import { SPEND_CATEGORY_TRANSLATIONS } from 'api/react-query/keys'
import { getCategoryTranslations } from 'SpendControl/endpoints/spend-control'

export const useGetCategoryTranslations = ({ categoryId }: { categoryId: string | undefined }) =>
  useQuery({
    queryKey: [SPEND_CATEGORY_TRANSLATIONS, categoryId],
    queryFn: () => getCategoryTranslations(categoryId as string),
    enabled: Boolean(categoryId),
  })
